import React, {Component} from 'react';
import {
  Modal,
  ModalBody
} from 'reactstrap'

class Confirmation extends Component {

  render() {
    return (
      <Modal isOpen={true} className="text-center">
        <ModalBody>The {this.props.dataType} data has been saved.</ModalBody>
      </Modal>
    )
  }
}

export default Confirmation



// WEBPACK FOOTER //
// ./src/views/Confirmation.js